import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  private readonly langs = [
    {id: 'fr', name: 'French'},
    {id: 'en', name: 'English'},
    {id: 'es', name: 'Spanish'},
    {id: 'it', name: 'Italian'},
    {id: 'pt', name: 'Portuguese'},
    {id: 'de', name: 'German'},
    {id: 'ru', name: 'Russian'},
    {id: 'uk', name: 'Ukrainian'},
    {id: 'pl', name: 'Polish'},
    {id: 'zh', name: 'Chinese'},
  ];

  getPartnerLangs(): any[] {
    return this.langs;
  }

  getFlag(lang: any): string {
    return '/images/lang/' + lang.id + '.svg';
  }
}
